import { useState } from "react";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { RootState } from "app/store";
import { btnDelay } from "common/utils";
import { NotificationDetailModal } from "./components";

interface NotificationData {
  date: string;
  title: string;
  content: string;
}

export const NotificationPage = () => {
  const config = useSelector((state: RootState) => state.config.parentConfig);
  const notifications = useSelector((state: RootState) => state.config.notification.parents);

  const [detailShow, setDetailShow] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState<NotificationData | null>(null);

  const handleNotificationClick = (notification: NotificationData) => {
    btnDelay(() => {
      setSelectedNotification(notification);
      setDetailShow(true);
    });
  };

  const handleCloseDetail = () => {
    btnDelay(() => {
      setDetailShow(false);
      setSelectedNotification(null);
    });
  };

  const displayNotifications = notifications.map((n) => {
    const localeData = n[config.locale] || n["ja_kanji"];
    return {
      date: localeData?.date || "",
      title: localeData?.title || "",
      content: localeData?.content || "",
      excerpt: localeData?.content || "",
      unread: dayjs().diff(n.published_at, "day") < 7,
    };
  });

  return (
    <>
      <NotificationDetailModal
        open={detailShow}
        notification={selectedNotification}
        onClose={handleCloseDetail}
      />

      <div className="flex-col-el gap-3">
        {displayNotifications.map((notification, index) => (
          <div
            key={index}
            className={`bg-white rounded-[16px] py-5 px-6 cursor-pointer transition-all hover:bg-surface border-l-4 ${
              notification.unread ? "border-l-blue-100 bg-surface" : "border-l-transparent"
            }`}
            onClick={() =>
              handleNotificationClick({
                date: notification.date,
                title: notification.title,
                content: notification.content,
              })
            }
          >
            <div className="flex-row-el items-center justify-between mb-2">
              <span className="text-[19px] text-gray2-100">{notification.date}</span>
              {notification.unread && (
                <span className="inline-flex items-center px-2.5 py-1 bg-danger text-white rounded-[10px] text-[16px]">
                  NEW
                </span>
              )}
            </div>
            <div className="text-[24px] text-textcolor-black mb-1.5">{notification.title}</div>
            <div className="text-[24px] text-gray2-100 leading-[1.5] line-clamp-2">
              {notification.excerpt}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
